<template>
	<div class="loading_bg">
		<div class="img">
			<!-- <img src="@/assets/images/load.gif" class="img_cover" /> -->
		</div>
	</div>
</template>

<script>
</script>

<style lang="scss" scoped>
	.loading_bg {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		z-index: 2;
		background: rgba(0, 0, 0, .5);
		display: flex;
		align-items: center;
		justify-content: center;

		.img {
			display: block;
			background: none;
			width: 200px;
			height: 200px;
		}
	}
</style>